@let f = form();
<div [class.pdw-panel--embedded]="embedded()" class="pdw-panel pdw-panel--action" aria-label="Current step">
  @if (presentation() !== 'uc2' || f.stepKey !== 'execute_actions') {
    <h4 class="pdw-panel__title">{{ f.title ?? labelFor(f.stepKey) }}</h4>
  }

  @if (item(); as workItem) {
    @let showAction = !(presentation() === 'uc2' && embedded() && f.stepKey === 'execute_actions' && actionDescriptionShown());
    @if (showAction || workItem.completionCriteria.length > 0) {
    <dl class="pdw-record pdw-record--action">
      @if (showAction) {
      <div>
        <dt>Action</dt>
        <dd>
          @if (presentation() === 'uc2') {
            <app-console-summary-markdown [text]="workItem.description ?? '--'" />
          } @else {
            {{ workItem.description ?? '--' }}
          }
        </dd>
      </div>
      }
      @if (workItem.completionCriteria.length > 0) {
        <div>
          <dt>Done when</dt>
          <dd>
            @if (presentation() === 'uc2') {
              @for (criterion of workItem.completionCriteria; track $index) {
                <app-console-summary-markdown [text]="criterion" />
              }
            } @else {
              {{ workItem.completionCriteria.join('; ') }}
            }
          </dd>
        </div>
      }
    </dl>
    }
  }

  @if (commandError(); as error) {
    <p class="gate__blocked" role="alert">{{ error }}</p>
  }

  @if (canClaim() || canDecide()) {
    @if (!submitClaims() && canClaim() && !claimPending()) {
      <p class="pdw-claim-notice">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
        Filling in this step assigns it to you.
      </p>
    }
    <div [attr.aria-busy]="claimPending()" [class.gate__form--busy]="claimPending()" class="gate__form">
      @for (field of visibleFields(); track field.key) {
        <div [class.uc2-validity-field]="presentation() === 'uc2' && field.name === 'validity'" class="gate__field gate__field--wide">
          <div class="gate__label-row">
          <label [id]="'eng-label-' + field.key"
            [attr.for]="presentation() === 'uc2' && (field.name === 'validity' || field.name === 'selectedCandidate') ? null : 'eng-' + field.key"
            class="gate__label">
            {{ field.label }}
            @if (isRequired(field)) {
              <span class="gate__required">required</span>
            } @else if (presentation() !== 'uc2' || field.name !== 'selectedCandidate') {
              <span class="gate__muted">(optional)</span>
            }
          </label>
          </div>
          @switch (field.type) {
            @case ('vocab') {
              @if (presentation() === 'uc2' && field.name === 'validity') {
                <div [attr.aria-labelledby]="'eng-label-' + field.key" class="uc2-validity" role="group">
                  @for (value of field.values; track value) {
                    <label class="gate__radio">
                      <input [formControl]="controls()[field.key]" [name]="field.key" [attr.name]="field.key"
                        [value]="value" (change)="onInteraction()" type="radio" />
                      {{ value === 'NotReal' ? 'Not a real exception' : labelFor(value) }}
                    </label>
                  }
                </div>
              } @else {
              <select [formControl]="controls()[field.key]" [id]="'eng-' + field.key"
                [attr.aria-describedby]="field.record === 'analyst_decision' && field.name === 'assessedAssessment' && confirmationBlock() ? 'eng-assessment-block' : null"
                (change)="onInteraction()" class="gate__control">
                @if (presentation() !== 'uc2' || f.stepKey !== 'analyst_gate' ||
                     field.record !== 'analyst_decision' || field.name !== 'assessedAssessment') {
                  <option value="">Select</option>
                }
                @for (value of field.values; track value) {
                  <option [value]="value">{{ labelFor(value) }}</option>
                }
              </select>
              }
            }
            @case ('ref') {
              @if (presentation() === 'uc2' && field.name === 'selectedCandidate') {
                <div [attr.aria-labelledby]="'eng-label-' + field.key" class="uc2-causes pdw-cands" role="group">
                  @for (candidate of candidates(); track candidate.id) {
                    @let selectable = candidates().length > 1 || controls()[field.key].value !== candidate.id;
                    <ng-template #candidateContent>
                        <span class="pdw-cand__body uc2-cause__body">
                          <span class="pdw-cand__head">
                            <app-console-summary-markdown [text]="candidate.label"
                              [id]="'eng-candidate-' + field.key + '-' + candidate.id" class="pdw-cand__title" />
                            @if (candidate.family) { <span class="pdw-cand__chip">{{ labelFor(candidate.family) }}</span> }
                          </span>
                          @if (candidate.rationale) { <app-console-summary-markdown [text]="candidate.rationale" class="pdw-cand__rationale" /> }
                        </span>
                    </ng-template>
                    <div [class.pdw-cand--selected]="selectable && controls()[field.key].value === candidate.id" class="uc2-cause pdw-cand">
                      @if (selectable) {
                        <label class="pdw-cand__label">
                          <input [checked]="controls()[field.key].value === candidate.id" [disabled]="busy()"
                            [attr.aria-labelledby]="'eng-candidate-' + field.key + '-' + candidate.id"
                            (change)="selectCandidate(field, candidate)" type="radio" [name]="field.key" [value]="candidate.id" />
                          @if (candidates().length > 1) {
                            <span class="pdw-cand__rank" aria-hidden="true">
                              @if (candidate.rank !== undefined && candidate.rank !== null) { {{ candidate.rank }} } @else { <i class="pi pi-circle"></i> }
                            </span>
                          }
                          <ng-container [ngTemplateOutlet]="candidateContent" />
                        </label>
                      } @else {
                        <div class="pdw-cand__label pdw-cand__label--readonly">
                          <ng-container [ngTemplateOutlet]="candidateContent" />
                        </div>
                      }
                      @if (candidate.recommendedActions?.length) {
                        <div class="uc2-candidate-actions">
                          <div class="uc2-candidate-actions__info">
                            <h5 class="uc2-candidate-actions__heading"><i class="pi pi-info-circle" aria-hidden="true"></i> Recommended actions</h5>
                            @for (action of candidate.recommendedActions; track action.id) {
                              <app-console-summary-markdown [text]="action.description" class="uc2-candidate-actions__description" />
                            }
                          </div>
                        </div>
                      }
                    </div>
                  } @empty {
                    <p class="gate__blocked" role="status">No cause explanation is available for this workflow.</p>
                  }
                </div>
              } @else {
              <select [formControl]="controls()[field.key]" [id]="'eng-' + field.key" (change)="onInteraction()" class="gate__control">
                <option value="">Select</option>
                @for (candidate of candidates(); track candidate.id) {
                  <option [value]="candidate.id">{{ candidate.label }}</option>
                }
              </select>
              }
            }
            @case ('datetime') {
              <input
                [formControl]="controls()[field.key]"
                [id]="'eng-' + field.key"
                (input)="onInteraction()"
                type="datetime-local"
                class="gate__control" />
            }
            @default {
              <textarea
                [formControl]="controls()[field.key]"
                [id]="'eng-' + field.key"
                (input)="onInteraction()"
                class="gate__control"
                rows="2"></textarea>
            }
          }
        </div>
      }

      @if ((presentation() !== 'uc2' && allowReturnAndRelease() && allowRelease()) || reasonActions().length) {
        <div class="gate__field gate__field--wide">
          <label class="gate__label" for="eng-reason">
            Reason
            @if (reasonActions().length) {
              <span class="gate__muted">(required for {{ reasonActions().join(', ') }})</span>
            } @else {
              <span class="gate__muted">(optional)</span>
            }
          </label>
          <textarea [formControl]="reasonControl" (input)="onInteraction()" id="eng-reason" class="gate__control" rows="2"></textarea>
          @if (recordActionBlockedByReason()) {
            <p class="gate__muted" role="status">A reason selects an exception path. Choose Not applicable or Cannot complete, or clear the reason to Record action.</p>
          }
        </div>
      }
    </div>

    <!-- Always rendered so screen readers announce the claim in progress. -->
    <div class="pdw-command" aria-live="polite">
      @if (claimPending()) {
        <p class="pdw-command__status">
          <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
          {{ submitClaims() ? 'Submitting decision...' : 'Assigning this step to you…' }}
        </p>
      }
    </div>

    @if (validationMessage(); as message) {
      <p class="gate__blocked" role="status">{{ message }}</p>
    }

    @if (confirmationBlock(); as message) {
      <p id="eng-assessment-block" class="gate__blocked" role="alert">{{ message }}</p>
    }

    @if (submitBlock(); as message) {
      <p class="gate__blocked" role="alert">{{ message }}</p>
    }

    <div class="gate__actions">
      @if (canRelease()) {
        <button
          [disabled]="busy() || reasonBlank()"
          (click)="onRelease()"
          type="button"
          class="gate__btn gate__btn--ghost">
          Release to queue
        </button>
      }
      @if (canReturn()) {
        <button
          [disabled]="!canDecide() || busy() || (returnNeedsReason() && reasonBlank())"
          (click)="onReturn()"
          type="button"
          class="gate__btn gate__btn--ghost">
          Return to {{ returnTarget() }}@if (returnToName(); as name) { ({{ name }})}
        </button>
      }
      @for (outcome of decisionOutcomes(); track outcome) {
        <button
          [disabled]="outcomeDisabled(outcome)"
          (click)="onDecide(outcome)"
          type="button"
          class="gate__btn gate__btn--primary">
          {{ actionLabel(outcome) }}
        </button>
      }
    </div>
  } @else {
    <p class="pdw-waiting">{{ ownerLabel() }}.</p>
  }
</div>
